export default __webpack_public_path__ + "static/media/weHeartNDIS2020v3.4449d718.jpg";